import { render, staticRenderFns } from "./ExemptibleUnits.vue?vue&type=template&id=10e27ca6&scoped=true"
import script from "./ExemptibleUnits.vue?vue&type=script&lang=js"
export * from "./ExemptibleUnits.vue?vue&type=script&lang=js"
import style0 from "./ExemptibleUnits.vue?vue&type=style&index=0&id=10e27ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e27ca6",
  null
  
)

export default component.exports